import React, { forwardRef } from 'react';
import { Scrollbars, ScrollbarProps } from 'react-custom-scrollbars-2';

export type TScrollbarElem = {
  view: HTMLDivElement;
};

interface CustomScrollbarProps extends ScrollbarProps {
  children: React.ReactNode;
  withHorizontal?: boolean;
}

const CustomScrollbar = forwardRef<HTMLDivElement, CustomScrollbarProps>(
  ({ children, style, withHorizontal = false, ...props }, ref) => {
    // Vertical thumb
    const renderThumbVertical = ({ style: thumbStyle, ...thumbProps }: any) => {
      const combinedStyle: React.CSSProperties = {
        backgroundColor: 'darkgrey',
        borderRadius: '10px',
        minHeight: '20px',
        ...thumbStyle,
      };
      return <div style={combinedStyle} {...thumbProps} />;
    };

    // Vertical track
    const renderTrackVertical = ({ style: trackStyle, ...trackProps }: any) => {
      const combinedStyle: React.CSSProperties = {
        background: '#f1f1f1',
        borderRadius: '10px',
        width: '6px',
        right: '0',
        bottom: '2px',
        top: '2px',
        ...trackStyle,
      };
      return <div style={combinedStyle} {...trackProps} />;
    };

    // Horizontal thumb
    const renderThumbHorizontal = ({ style: thumbStyle, ...thumbProps }: any) => {
      const combinedStyle: React.CSSProperties = {
        backgroundColor: 'darkgrey',
        borderRadius: '10px',
        minWidth: '20px',
        height: '6px',
        ...thumbStyle,
      };
      return <div style={combinedStyle} {...thumbProps} />;
    };

    // Horizontal track
    const renderTrackHorizontal = ({ style: trackStyle, ...trackProps }: any) => {
      const combinedStyle: React.CSSProperties = {
        background: '#f1f1f1',
        borderRadius: '10px',
        height: '6px',
        left: '2px',
        right: '2px',
        bottom: '0',
        ...trackStyle,
      };
      return <div style={combinedStyle} {...trackProps} />;
    };

    const horizontalScrollbarProps = withHorizontal
      ? {
          renderThumbHorizontal,
          renderTrackHorizontal,
        }
      : {};

    return (
      <Scrollbars
        as="div"
        renderThumbVertical={renderThumbVertical}
        renderTrackVertical={renderTrackVertical}
        {...horizontalScrollbarProps}
        style={style}
        universal
        autoHide
        {...props}
        ref={ref as React.ForwardedRef<Scrollbars>}
      >
        {children}
      </Scrollbars>
    );
  }
);

export { CustomScrollbar };
